import { useState, useEffect, useCallback } from "react";
import { fetchBudgets } from "../../api/finances/budgetAPI";

export function useBudgets() {
  const [isLoading, setIsLoading] = useState(true);
  const [budgets, setBudgets] = useState([]);
  const [summary, setSummary] = useState(null);

  const loadData = useCallback(async () => {
    setIsLoading(true);
    const result = await fetchBudgets();
    if (result.success) {
      setBudgets(result.data.budgets);
      setSummary(result.data.summary);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return { isLoading, budgets, summary, refresh: loadData };
}
